<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-12 14:56:44
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-05-26 16:53:52
 * @FilePath: \Home\Transfor-website\src\views\pc\Developer\StartBuilding.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="StartBuilding">
      <div class="StartBuilding-W">
        <p><span>Start </span><span>building</span></p>
        <div class="StartBuilding-bottom">
          <div class="StartBuilding-bottom-W">
            <ul class="clearfix">
              <li v-for="(item, index) in list" :key="index">
                <p>{{ item.name }}</p>

                <p v-if="item.id == 0">
                  <a
                    href="https://www.tfsc.io/doc/learn/run-rpc-node"
                    target="_blank"
                    ><button>More</button></a
                  >
                </p>
                <p v-if="item.id == 1">
                  <a
                    href="https://www.tfsc.io/doc/learn/run-rpc-node"
                    target="_blank"
                    ><button>More</button></a
                  >
                </p>
                <p v-if="item.id == 2">
                 <button @click="Masg()">More</button>
                </p>
                <p v-if="item.id == 3">
                  <a
                    href="https://www.tfsc.io/doc/structure/contract"
                    target="_blank"
                    ><button>More</button></a
                  >
                </p>
                <p v-if="item.id == 4">
                  <a
                    href="https://www.tfsc.io/doc/learn/tfsc-update"
                    target="_blank"
                    ><button>More</button></a
                  >
                </p>
                <!-- <button @click="Masg()">More</button> -->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        // {
        //   name: "Run the bridge node",
        //   ImgUrl: "",
        // },
        {
          name: "Run the validator",
          ImgUrl: "",
          id: 0,
        },
        {
          name: "Run the RPC node",
          ImgUrl: "",
          id: 1,
        },
        {
          name: "Add the TFSC to the exchange",
          ImgUrl: "",
          id: 2,
        },
        {
          name: "Contract development guide",
          ImgUrl: "",
          id: 3,
        },
        {
          name: "Test the network deployment application",
          ImgUrl: "",
          id: 4,
        },
      ],
      W: document.body.clientWidth + "px",
    };
  },

  mounted() {},

  methods: {
    Masg() {
      this.$message("Coming Soon");
    },
  },
};
</script>

<style lang="less" scoped>
.StartBuilding {
  width: 100%;
  // background: url("../../../assets/pc/Building/Building1.png") no-repeat;
  // background-size: 100% !important;
  background: #f4f4f4;
  .StartBuilding-W {
    width: 1320px;
    margin: 0 auto;
    padding: 209px 0 0 0;
    background: #f4f4f4;
    p {
      span {
        font-size: 80px;
        font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #141414;
        line-height: 112px;
      }
      span:nth-child(2) {
        color: #cf61dc;
      }
    }
  }
}
.StartBuilding-bottom {
  width: 100%;
  background: #f4f4f4;
  padding-top: 110px;
  .StartBuilding-bottom-W {
    width: 1320px;
    margin: 0 auto;
    padding: 0 0 255px 0;
    ul {
      position: relative;
      height: 1130px;
      li {
        width: 650px;
        height: 370px;
        background: #cb5fd8;
        border-radius: 15px 15px 15px 15px;
        // float: left;
        padding: 24px 30px;
        p:nth-child(1) {
          width: 439px;
          font-size: 40px;
          font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
          font-weight: bold;
          color: #141141;
          line-height: 60px;
          //   margin-top: 24px;
        }
        button {
          width: 180px;
          height: 50px;
          opacity: 1;
          font-size: 20px;
          font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
          font-weight: 500;
          background: #141414;
          line-height: 28px;
          border-radius: 25px 25px 25px 25px;
          margin-top: 196px;
          color: #ffffff;
          border: 2px solid #141414;
        }
        button:hover {
          background: #ffffff;
          color: #141414;
        }
      }
      li:hover {
        box-shadow: 0px 27px 26px 1px rgba(0, 0, 0, 0.11999999731779099);
      }
      li:nth-child(1) {
        button {
          margin-top: 196px;
        }
        position: absolute;
        top: 0;
        left: 0;
        margin-right: 10px;
        transition: all 0.3s;
      }
      li:nth-child(1):hover {
        transition: all 0.3s;
        top: -2px;
        background: #df8ae6;
      }
      li:nth-child(2) {
        background: #6c85f5;
        button {
          margin-top: 196px;
        }
        position: absolute;
        top: 0;
        right: 0px;
        transition: all 0.3s;
        // margin-left: 10px;
      }
      li:nth-child(2):hover {
        top: -2px;
        transition: all 0.3s;
        background: #99afff;
      }
      li:nth-child(3) {
        background: #60c9db;
        button {
          margin-top: 137px;
        }
        position: absolute;
        top: 390px;
        left: 0;
        transition: all 0.3s;
      }
      li:nth-child(3):hover {
        top: 388px;
        transition: all 0.3s;
        background: #8bdde8;
      }
      li:nth-child(4) {
        background: #60db92;
        button {
          margin-top: 136px;
        }
        position: absolute;
        top: 390px;
        right: 0px;
        transition: all 0.3s;
      }
      li:nth-child(4):hover {
        top: 388px;
        transition: all 0.3s;
        background: #8be8ad;
      }
      li:nth-child(5) {
        background: #f5a36c;
        transition: all 0.3s;
        button {
          margin-top: 76px;
        }
        position: absolute;
        bottom: -20px;
        left: 0;
      }
      li:nth-child(5):hover {
        bottom: -18px;
        background: #ffc599;
        transition: all 0.3s;
      }
      // li:nth-child(6) {
      //   background: #f5a36c;
      //   position: absolute;
      //   bottom: -20px;
      //   right: 0px;
      //   transition: all 0.3s;
      //   button {
      //     margin-top: 76px;
      //   }
      // }
      // li:nth-child(6):hover {
      //   bottom: -18px;
      //   background: #ffc599;
      //   transition: all 0.3s;
      // }
    }
  }
}
</style>
